import React, { useCallback, useEffect, useState } from "react";
import Styles from "./ChargesContainer.module.css";
import { Modal } from "@mui/material";
import { Close, Edit, CheckCircleOutline } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { publicStateUT } from "../../../../Redux/Slices/publicSlice";
import SelectInput from "../../../../commons/Inputs/Select/SelectInput";
import AddIcon from "@mui/icons-material/Add";
import {
  assignCharge,
  chargesUser,
  consumerCharges,
  deleteCharges,
  deleteDefaultCharges,
  deteteNewCharge,
  generatorCharges,
  removeCharges,
} from "../../../../Services/Payments/PaymentApi";
import { getCompanyByStateId } from "../../../../Services/GNA/GetData";
import AssignCharge from "../AssignCharge/AssignCharge";
import ConfirmationModal from "../../../../commons/ConfirmationModal/ConfirmationModal";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import CreateCharge from "../CreateCharge/CreateCharge";
import { create } from "@mui/material/styles/createTransitions";
import {
  getContractRequest,
  updateContractData,
} from "../../../../Services/BuySell/Listing";
import { sendErrorMail } from "../../../../Services/Schedule/schedule";
import { ErrorMessage } from "../../../../commons/Toast/ErrorMessage";

const processCharges = (response, type) => {
  const data = response?.data?.data || [];
  return data.map((item) => ({
    ...item,
    // type: type,
  }));
};

const ChargesContainer = ({ open, handleClose }) => {
  const state = useSelector((state) => state?.publicSlice?.stateUT);
  const dispatch = useDispatch();

  const [selState, setSelState] = useState({});
  const [allCharges, setAllCharges] = useState([]);

  const [company, setCompany] = useState([]);
  const [companySel, setCompanySel] = useState({});

  const [entityList, setEntityList] = useState([]);
  const [entitySelected, setEntitySelected] = useState([]);

  const [addChargeModal, setAddChargeModal] = useState(false);
  const [assignChargeModal, setAssignChargeModal] = useState(false);
  const [createChargeModal, setCreateChargeModal] = useState(false);

  const [chargeIds, setChargeIds] = useState([]);

  const [confirmModal, setConfirmModal] = useState({
    value: false,
    type: "",
    data: "",
    header: "",
  });
  const [chargeListConsumer, setChargeListConsumer] = useState([]);
  const [chargeListGenerator, setChargeListGenerator] = useState([]);

  const [consumerRequest, setConsumerRequest] = useState([]);
  const [generatorRequest, setGeneratorRequest] = useState([]);

  const [delData, setDelData] = useState({
    companyId: null,
    conId: null,
    genId: null,
    chargeId: null,
  });

  const [editData, setEditData] = useState({
    status: false,
    data: null,
  });

  useEffect(() => {
    dispatch(publicStateUT());
    getAllCharges();
  }, [dispatch]);

  useEffect(() => {
    if (entitySelected?.filter((ele) => ele?.type === "Consumer")?.length > 0) {
      handleConsumerCharges();
    }
    if (
      entitySelected?.filter((ele) => ele?.type === "Generator")?.length > 0
    ) {
      handleGeneratorCharges();
    }
  }, [entitySelected]);

  const handleClean = () => {
    setChargeListConsumer([]);
    setChargeListGenerator([]);
    setEntitySelected([]);
    setGeneratorRequest([]);
    setConsumerRequest([]);
  };

  const handleSelEntity = (val) => {
    if (val?.name === "Select All") {
      setEntitySelected((prev = []) => {
        const toAdd = (entityList || []).filter(
          (ele) => ele?.name !== "Select All",
        );
        const existingIds = new Set(prev.map((e) => e?.id));
        const merged = [
          ...prev,
          ...toAdd.filter((e) => !existingIds.has(e?.id)),
        ];
        return merged;
      });
      return;
    }
    setEntitySelected((prev) => {
      if (!val) return prev;
      // avoid duplicates based on id (adjust key if different)
      const exists = prev.some((e) => e?.id === val?.id);
      return exists ? prev : [...prev, val];
    });
  };

  const handleSelCompany = (val) => {
    handleClean();
    let initData = [{ consumerId: 0, consumerName: "Select All" }];
    let data = [...initData, ...val?.consumers, ...val?.generators];
    const entity = data.map((c) => {
      const { consumerId, consumerName, generatorId, generatorName, ...rest } =
        c;
      return {
        ...rest,
        id: consumerId || generatorId,
        name: consumerName || generatorName,
        type: consumerId ? "Consumer" : "Generator",
      };
    });
    setEntityList(entity);
    setCompanySel(val);
  };

  const handleSelState = async (val) => {
    handleClean();
    setSelState(val);
    let res = await getCompanyByStateId(val?.id);
    if (res?.data?.code === 200) {
      const companies = (res?.data?.data || []).map((c) => {
        const { companyId, companyName, ...rest } = c;
        return { ...rest, id: companyId ?? c.id, name: companyName ?? c.name };
      });
      setCompany(companies);
    }
  };

  const getAllCharges = useCallback(async () => {
    try {
      let res = await chargesUser();
      setAllCharges(res?.data?.data);
    } catch (err) {
      console.error("Error fetching charges:", err);
    }
  }, []);

  const handleAssignCharges = (id) => {
    const ids = Array.isArray(id) ? id : [id];
    setChargeIds((prev) => [...prev, ...ids]);
    handleUpdateCharges(ids);
    setAssignChargeModal(false);
  };

  const handleUpdateCharges = async (ids) => {
    let payload = {
      companyId: companySel?.id,
      consumerIds: entitySelected
        ?.filter((ele) => ele?.type === "Consumer")
        ?.map((ele) => ele?.id),
      generatorIds: entitySelected
        ?.filter((ele) => ele?.type === "Generator")
        ?.map((ele) => ele?.id),
      chargeIds: ids || chargeIds,
    };
    let res = await assignCharge(payload);

    if (res?.data?.code === 200) {
      setConfirmModal(false);
      handleConsumerCharges();
      handleGeneratorCharges();
    } else if (res?.data?.code === 400) {
      const errorMessage = res?.data?.error || "An error occurred";
      setConfirmModal(false);
      ErrorMessage(errorMessage);
    } else {
      setConfirmModal(false);
      const errorMsg = res?.data?.message || "Unexpected error occurred";
      ErrorMessage(errorMsg);
    }
  };

  const getAllAssignCharges = () => {
    handleGeneratorCharges();
    handleConsumerCharges();
  };

  const handleConsumerCharges = async () => {
    const consumers =
      entitySelected?.filter((ele) => ele?.type === "Consumer") || [];

    const payload = {
      consumerIds: consumers.map((ele) => ele?.id),
    };

    let res = await consumerCharges(payload);

    if (res?.data?.code === 200) {
      handleViewReq("consumer", payload?.consumerIds[0]);
      // Merge the names into the incoming data
      const enrichedData = (res?.data?.data || []).map((chargeItem) => {
        // Find the matching entity from your selection list
        const match = consumers?.filter(
          (ele) => ele?.id === chargeItem?.consumerId,
        )[0];

        return {
          ...chargeItem,
          entityName: match?.name || "Unknown", // Injecting the name here
        };
      });

      setChargeListConsumer(enrichedData);
    }
  };

  const errorMailHandle = async (msg, entityType, entityId) => {
    const payload = {
      templateName: "DisasterManagementClientNotification",
      customData: { subject: "New Charge Addition Successful", body: msg },
      toEmail: "stage-otc@gna.energy",
      generatorIds: entityType === "generator" ? [entityId] : null,
      consumerIds: entityType === "consumer" ? [entityId] : null,
    };
    const res = await sendErrorMail(payload);
    if (res?.data?.code === 200) {
    } else {
      console.error("Failed to send error mail", res);
    }
  };

  const handleUpdateConn = async (id, entityType, item) => {
    let msg =
      "Please be advised that the platform has been updated to reflect the new charges outlined in the GNA documentation. You are now authorized to initiate Schedule Generation.";
    let res = await updateContractData(id, true);
    if (res?.data?.code === 200) {
      if (entityType === "consumer") {
        errorMailHandle(
          msg,
          entityType,
          item?.capacityConsumer?.consumerDetailId,
        );
        setConsumerRequest((prev) => prev.filter((item) => item?.id !== id));
      } else {
        errorMailHandle(
          msg,
          entityType,
          item?.capacityGenerator?.generatorPlantId,
        );
        setGeneratorRequest((prev) => prev.filter((item) => item?.id !== id));
      }
    }
  };

  const handleGeneratorCharges = async () => {
    // 1. Get only the Generator entities
    const generators =
      entitySelected?.filter((ele) => ele?.type === "Generator") || [];

    // 2. Prepare the payload (just the IDs)
    const payload = {
      generatorIds: generators.map((ele) => ele?.id),
    };

    let res = await generatorCharges(payload);

    if (res?.data?.code === 200) {
      // 3. Create a lookup object for quick name matching: { "id1": "Name1", "id2": "Name2" }
      const generatorMap = Object.fromEntries(
        generators.map((g) => [g.id, g.name]),
      );

      // 4. Enrich the API response with names
      const enrichedData = (res?.data?.data || []).map((chargeItem) => ({
        ...chargeItem,
        entityName: generatorMap[chargeItem?.id] || "Unknown Generator",
      }));

      setChargeListGenerator(enrichedData);
      handleViewReq("generator", payload?.generatorIds[0]);
    }
  };

  const handleViewReq = async (type, id, name) => {
    if (type === "consumer") {
      const exists = consumerRequest.some((item) => item.entityId === id);
      if (exists) {
        setConsumerRequest((prev) =>
          prev.filter((item) => item.entityId !== id),
        );
        return;
      }
    } else {
      const exists = generatorRequest.some((item) => item.entityId === id);
      if (exists) {
        setGeneratorRequest((prev) =>
          prev.filter((item) => item.entityId !== id),
        );
        return;
      }
    }

    let res = await getContractRequest(
      type === "consumer" ? "CONSUMER" : "GENERATOR",
      id,
    );
    if (res?.data?.code === 200) {
      const enrichedData = (res?.data?.data || []).map((item) => ({
        ...item,
        entityType: type,
        entityId: id,
        name,
      }));
      if (type === "consumer") {
        setConsumerRequest((prev) => [...prev, ...enrichedData]);
      } else {
        setGeneratorRequest((prev) => [...prev, ...enrichedData]);
      }
    }
  };

  const handleConfirmModal = ({ type, data, header }) => {
    setConfirmModal({
      value: true,
      type,
      data,
      header,
    });
  };

  const handleSpeceficDeleteCharge = async () => {
    let payload = {
      companyId: delData?.companyId,
      consumerIds: delData?.conId ? [delData?.conId] : [],
      generatorIds: delData?.genId ? [delData?.genId] : [],
      chargeIds: [delData?.chargeId],
    };
    let res = await removeCharges(payload);
    if (res?.data?.code === 200) {
      setConfirmModal(false);
      handleConsumerCharges();
      handleGeneratorCharges();
    }
  };

  const handleDelete = async (id) => {
    let res = await deteteNewCharge(id);
    if (res?.data?.code === 200) {
      await getAllCharges();
      chargesUser();
    }
  };

  const handleRemoveEnetityandCharges = async (ele) => {
    if (ele?.walletAccount?.consumerId) {
      setChargeListConsumer((prev) =>
        prev.filter(
          (item) => item?.consumerId !== ele?.walletAccount?.consumerId,
        ),
      );
    }

    if (ele?.walletAccount?.generatorId) {
      setChargeListGenerator((prev) =>
        prev.filter(
          (item) => item?.generatorId !== ele?.walletAccount?.generatorId,
        ),
      );
    }

    setEntitySelected((prev) => prev.filter((item) => item.id !== ele.id));
  };

  return (
    <>
      {confirmModal?.value && (
        <ConfirmationModal
          open={confirmModal?.value}
          handleClose={() =>
            setConfirmModal({
              value: false,
              type: "",
              data: "",
              header: "",
            })
          }
          data={confirmModal?.data}
          header={confirmModal?.header}
          handleSubmit={() => {
            if (confirmModal?.type === "assign") {
              handleUpdateCharges();
            } else if (confirmModal?.type === "delete_charge") {
              handleSpeceficDeleteCharge();
            }
          }}
        />
      )}
      {assignChargeModal && (
        <AssignCharge
          open={assignChargeModal}
          handleClose={() => {
            setAssignChargeModal(false);
            setEditData({});
          }}
          charges={allCharges}
          handleAssignCharges={handleAssignCharges}
          editData={editData}
          getAllAssignCharges={getAllAssignCharges}
        />
      )}
      {(createChargeModal || editData?.status) && (
        <CreateCharge
          open={createChargeModal || editData?.status}
          handleClose={() => {
            setCreateChargeModal(false);
            setEditData({
              status: false,
              data: null,
            });
          }}
          handleUpdate={getAllCharges}
          editData={editData}
        />
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.chargesContainer}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.headingText}`}
          >
            <div className={`headingText ${Styles.finalHead}`}>
              Losses and Charges
            </div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div className={Styles.chargesElementContainer}>
            <div className={Styles.inputSelectionCont}>
              <div className={`display_flex_row ${Styles.containerHeading}`}>
                <div className={Styles.containerHeadingText}>
                  Entity/Company Selection
                </div>
                <div
                  className={Styles.resetText}
                  onClick={() => {
                    setEntitySelected([]);
                  }}
                >
                  Reset
                </div>
              </div>
              <div className={Styles.entitySelectionContainer}>
                <div>
                  <SelectInput
                    list={state}
                    value={selState}
                    onChange={(val) => handleSelState(val)}
                    heading={"State"}
                    example={"Select State"}
                  />
                </div>
                <div>
                  <SelectInput
                    list={company}
                    value={companySel}
                    onChange={(val) => handleSelCompany(val)}
                    heading={"Company"}
                    example={"Select Company"}
                  />
                </div>
                <div>
                  <SelectInput
                    list={entityList}
                    value={{}}
                    onChange={(val) => handleSelEntity(val)}
                    heading={"Entity"}
                    example={"Select Entity"}
                  />
                </div>
                <div className={`scroll_bar_y ${Styles.selectedEntities}`}>
                  {entitySelected?.map((ele) => (
                    <div
                      className={`display_flex_row ${Styles.entitySelectedElements}`}
                    >
                      <div>
                        {ele?.name} ({ele?.type})
                      </div>
                      <Close
                        style={{
                          fontSize: "14px",
                          color: "red",
                          cursor: "pointer",
                        }}
                        onClick={() => handleRemoveEnetityandCharges(ele)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div
              className={Styles.chargesSelectionContainer}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <div className={`display_flex_row ${Styles.containerHeading}`}>
                <div className={Styles.containerHeadingText}>Charges</div>
                {entitySelected?.length > 0 ? (
                  <div
                    className={Styles.addAdminCntainer}
                    onClick={() => setAssignChargeModal(true)}
                  >
                    <AddIcon style={{ fontSize: "16px" }} />
                    <span>Assign Charge</span>
                  </div>
                ) : (
                  <div
                    className={Styles.addAdminCntainer}
                    onClick={() => setCreateChargeModal(true)}
                  >
                    <AddIcon style={{ fontSize: "16px" }} />
                    <span>Add New Charge</span>
                  </div>
                )}
              </div>
              <div
                className={Styles.entityListContainer}
                style={{
                  flex:
                    consumerRequest?.length > 0 || generatorRequest?.length > 0
                      ? "0 0 50%"
                      : "1 1 0",
                  overflow: "hidden",
                  height: "auto",
                }}
              >
                {entitySelected?.length === 0 ? (
                  <>
                    <div className="display_flex_row tableHeading">
                      <div style={{ width: "50%" }}>Charge Name</div>
                      <div style={{ width: "15%" }}>Type</div>
                      <div style={{ width: "15%" }}>Editable</div>
                      <div style={{ width: "15%" }}>Alter</div>
                    </div>
                    <div className={`scroll_bar_y ${Styles.chargesContainers}`}>
                      {allCharges?.map((ele) => (
                        <div className="display_flex_row tableDetails">
                          <div
                            className="textOverflow"
                            title={ele?.name}
                            style={{ width: "50%" }}
                          >
                            {ele?.name}
                          </div>
                          <div style={{ width: "15%" }}>{ele?.type}</div>
                          <div style={{ width: "15%" }}>
                            {ele?.isEditable ? "Yes" : "No"}
                          </div>
                          <div
                            style={{
                              width: "15%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "4px",
                            }}
                          >
                            <Edit
                              onClick={() => {
                                setEditData({
                                  status: true,
                                  data: ele,
                                });
                              }}
                              style={{
                                fontSize: "18px",
                                cursor: "pointer",
                                color: "#f1935c",
                              }}
                            />
                            <DeleteIcon
                              style={{
                                fontSize: "18px",
                                cursor: "pointer",
                                color: "red",
                              }}
                              onClick={() => handleDelete(ele?.id)}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="display_flex_row tableHeading">
                      <div style={{ width: "20%" }}>Entity Name</div>
                      <div style={{ width: "25%" }}>Charge Name</div>
                      <div style={{ width: "15%" }}>Value</div>
                      <div style={{ width: "15%" }}>Type</div>
                      <div style={{ width: "15%" }}>Frequency</div>
                      <div style={{ width: "5%" }}>Edit</div>
                    </div>
                    <div className={`scroll_bar_y ${Styles.chargesContainers}`}>
                      {chargeListConsumer?.map((elem) => (
                        <>
                          {elem?.charges?.map((ele) => (
                            <div className="display_flex_row tableDetails">
                              <div style={{ width: "20%" }}>
                                {elem?.entityName}
                              </div>
                              <div
                                title={ele?.name}
                                style={{
                                  width: "25%",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textAlign: "left",
                                }}
                              >
                                {ele?.name}
                              </div>
                              <div style={{ width: "15%" }}>{ele?.value}</div>
                              <div style={{ width: "15%" }}>
                                {ele?.type === "PER_MW" ? "₹/kWh" : ele?.type}
                              </div>
                              <div style={{ width: "15%" }}>
                                {ele?.frequency === "ONE_TIME"
                                  ? "One Time"
                                  : ele?.frequency}
                              </div>
                              <div
                                className="display_flex_row_gap_8"
                                style={{ width: "5%" }}
                              >
                                <BorderColorIcon
                                  style={{
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    color: "#8c8a96",
                                  }}
                                  onClick={() => {
                                    setEditData({
                                      ...ele,
                                      companyName: elem?.companyName,
                                      entityId: elem?.consumerId,
                                      entityType: "Consumer",
                                    });
                                    setAddChargeModal(true);
                                    setAssignChargeModal(true);
                                  }}
                                />
                                <DeleteIcon
                                  style={{
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    color: "red",
                                  }}
                                  onClick={() => {
                                    setDelData({
                                      companyId: elem?.companyId,
                                      conId: elem?.consumerId,
                                      chargeId: ele?.id,
                                    });
                                    handleConfirmModal({
                                      type: "delete_charge",
                                      data: `Are you sure you want to delete charge ,${ele?.name} for ${elem?.companyName}?`,
                                      header: "Charges Confirmation",
                                    });
                                  }}
                                />
                              </div>
                            </div>
                          ))}
                        </>
                      ))}
                      {chargeListGenerator?.map((elem) => (
                        <>
                          {elem?.charges?.map((ele) => (
                            <div className="display_flex_row tableDetails">
                              <div style={{ width: "20%" }}>
                                {elem?.companyName}
                              </div>
                              <div
                                title={ele?.name}
                                style={{
                                  width: "25%",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textAlign: "left",
                                }}
                              >
                                {ele?.name}
                              </div>
                              <div style={{ width: "15%" }}>{ele?.value}</div>
                              <div style={{ width: "15%" }}>
                                {ele?.type === "PER_MW" ? "₹/kWh" : ele?.type}
                              </div>
                              <div style={{ width: "15%" }}>
                                {ele?.frequency === "ONE_TIME"
                                  ? "One Time"
                                  : ele?.frequency}
                              </div>
                              <div
                                className="display_flex_row_gap_8"
                                style={{ width: "5%" }}
                              >
                                {" "}
                                <BorderColorIcon
                                  style={{
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    color: "#8c8a96",
                                  }}
                                  onClick={() => {
                                    setEditData({
                                      ...ele,
                                      companyName: elem?.companyName,
                                      entityId: elem?.generatorId,
                                      entityType: "Generator",
                                    });
                                    setAssignChargeModal(true);
                                  }}
                                />
                                <DeleteIcon
                                  style={{
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    color: "red",
                                  }}
                                  onClick={() => {
                                    setDelData({
                                      companyId: elem?.companyId,
                                      genId: elem?.generatorId,
                                      chargeId: ele?.id,
                                    });
                                    handleConfirmModal({
                                      type: "delete_charge",
                                      data: `Are you sure you want to delete charge ,${ele?.name} for ${elem?.companyName}?`,
                                      header: "Charges Confirmation",
                                    });
                                  }}
                                />
                              </div>
                            </div>
                          ))}
                        </>
                      ))}
                    </div>
                  </>
                )}
              </div>
              {(consumerRequest?.length > 0 ||
                generatorRequest?.length > 0) && (
                <div
                  style={{
                    flex: "0 0 50%",
                    overflow: "hidden",
                    borderTop: "var(--border-level4)",
                  }}
                >
                  <div
                    className={`display_flex_row ${Styles.containerHeading}`}
                  >
                    <div className={Styles.containerHeadingText}>
                      Contract Requests
                    </div>
                  </div>
                  <div
                    style={{
                      height: "calc(100% - 45px)",
                      width: "95%",
                      margin: "0 auto",
                    }}
                  >
                    <div className="display_flex_row tableHeading">
                      <div style={{ width: "18%" }}>Entity</div>
                      <div style={{ width: "28%" }}>Contract ID</div>
                      <div style={{ width: "22%" }}>Consumer</div>
                      <div style={{ width: "22%" }}>Generator</div>
                      <div style={{ width: "10%" }}>Action</div>
                    </div>
                    <div
                      className={`scroll_bar_y ${Styles.chargesContainers}`}
                      style={{ height: "calc(100% - 36px)" }}
                    >
                      {[...consumerRequest, ...generatorRequest].map(
                        (item, idx) => (
                          <div
                            key={idx}
                            className="display_flex_row tableDetails"
                          >
                            <div style={{ width: "18%" }}>
                              {item?.name || item?.entityType}
                            </div>
                            <div
                              className="textOverflow"
                              title={item?.contractUniqueId || item?.id}
                              style={{ width: "28%" }}
                            >
                              {item?.contractUniqueId || item?.id}
                            </div>
                            <div
                              className="textOverflow"
                              title={item?.capacityConsumer?.consumerName}
                              style={{ width: "22%" }}
                            >
                              {item?.capacityConsumer?.consumerName || "-"}
                            </div>
                            <div
                              className="textOverflow"
                              title={item?.capacityGenerator?.generatorName}
                              style={{ width: "22%" }}
                            >
                              {item?.capacityGenerator?.generatorName || "-"}
                            </div>
                            <div
                              style={{
                                width: "10%",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <CheckCircleOutline
                                title="Finalize Charges"
                                style={{
                                  fontSize: "18px",
                                  cursor: "pointer",
                                  color: "green",
                                }}
                                onClick={() =>
                                  handleUpdateConn(
                                    item?.id,
                                    item?.entityType,
                                    item,
                                  )
                                }
                              />
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ChargesContainer;
